



























































import { computed, defineComponent } from "@vue/composition-api";

import { Session } from "@/tools/msa/models";
import { Item } from "@/tools/msa/models/item";
import { calculateDates } from "@/tools/msa/utils/dates";
import PageList from "@/tools/msa/components/export/PageList.vue";
import { compareNullableDates } from "@/tools/msa/utils/comparator";
import MapWithDefault from "@/tools/msa/utils/adts/map-with-default";
import { calculateDisplay, calculateType } from "@/tools/msa/utils/export";

interface Props {
  session: Session;
}

export default defineComponent({
  name: "ExportedTable",
  components: { PageList },
  props: {
    session: { type: Object, required: true }
  },
  setup(props: Props) {
    const itemsByType = computed(() =>
      props.session.documents
        .flatMap(document => document.items)
        .filter(item => ["code_match", "msa_custom"].includes(item.type))
        .flatMap<[Item, string, string, string]>(item =>
          calculateDates(item).map(
            date =>
              [item, calculateType(item), calculateDisplay(item), date] as [
                Item,
                string,
                string,
                string
              ]
          )
        )
        .sort((a, b) => compareNullableDates(a[3], b[3]))
        .reduce((map, [item, type, display, date]) => {
          map
            .get(type)
            .get(display)
            .get(date)
            .add(item);
          return map;
        }, new MapWithDefault(() => new MapWithDefault(() => new MapWithDefault(() => new Set()))))
    );

    return {
      itemsByType
    };
  }
});
